<template>
  <div :id="id" class="echart-wrap">
  </div>
</template>

<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
import '@/assets/js/bmap.js'
// import 'echarts/extension/bmap/bmap.js'
// require('echarts/extension/bmap/bmap.js')
export default {
  name: 'EchartWrap',
  mixins: [resize],
  props: {
    id: {
      type: String,
      default: new Date().getTime() + ''
    }
  },
  data () {
    return {
      chart: null
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.initEchart()
  },
  watch: {

  },
  methods: {
    initEchart () {
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
    },
    setEchartOption (value = {}) {
      this.$nextTick(() => {
        this.chart.setOption(value)
      })
      return this.chart
    },
    registerMap (data, op = {}) {
      echarts.registerMap('mapData', { geoJSON: data })
    }
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.echart-wrap
  height: 100%;
  width 100%
</style>
